


























import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import PageName from '@/router/PageName';

@Component
export default class DialogBase extends Vue {
  @Prop() private modal!: boolean;
  @Prop({ default: false }) noContentPadding?: boolean | null;

  @Emit()
  closeDialog() {
    return;
  }

  toLogin() {
    this.$router.push({ name: PageName.BSC_HC_020_006 });
  }
}
